import type { FaireProductEntity } from "../../entity_types/product";

export const p_mwgggrzbda: FaireProductEntity = {
  token: "p_mwgggrzbda",
  type: "product",
  name: "Always my Mother forever my Friend",
  brandToken: "b_ap32ulhtcg",
  brandName: "Match Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/24320d843f8e3c5b68d45b2e4fd1baddaf8c02c1b073eff6280e71de74b3a09f.png",
  galleryImageUrls: [],
  priceDollars: 9.5,
  description:
    '*The scent will vary on these candles\n\n100% Soy Wax Candle • Match Candles are lovingly hand-poured and packaged in Swift Current, SK.\n\nEvery candle is made with 100% cotton wicks or all natural wood wicks and high-quality pure soy wax to ensure you are burning elements free from nasty toxins and toxic chemicals such as phthalates, paraffin and parabens. You can safely burn Match Candles in your home and work area without any adverse side effects to yours or your family’s health.\n\n• Cleaner Burning\n• Non-Toxic - Don’t release toxins into the air as they burn\n• Burns up to 50% longer than paraffin wax\n• Renewable Resource\n• Vegetable Based\n• 50-60 hour burn time\n• 8.5oz candle\n\nFIRST BURN Soy wax has a memory. It remembers the melt pool it created the first time you lit your candle. Every time you light your candle after that first burn, your candle will melt to the same melt pool. Always let your wax melt pool reach the edges of the jar on the first burn to avoid tunneling; this will prolong the life of your candle. A full melt pool should take about 2-3 hours. Be sure to trim your cotton wicks to 1/4” before each burn and wood wicks to 1/8".\n',
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:19.713Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
